import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';

const drugFamilyHead = [
  {
    headerName: 'Comments Exists',
    field: 'cc_COMMENTS_EXIST',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    resizable: true,
    minWidth: Styles.Width_200,
    maxLength: Styles.Length_30,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ActionCellRender',
    cellClass: 'frr-overflow-visible ag-cell-action',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Drug Family Name',
    field: 'drugfamilyname',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellClass: 'frr-ellipsis-text',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'ToolTipRender',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Start Quarter',
    field: 'startquarter',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'StartQuarter',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Quarter',
    field: 'endquarter',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'EndQuarter',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Rebate Pricing Method',
    field: 'REBATE_PRICING_METHOD_CD',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_400,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'SelectBoxRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Volume Calculation',
    field: 'VOLUME_CALC_METHOD_CD',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_400,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'SelectBoxRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Market Share Calculation',
    field: 'MKT_SHARE_CALC_METHOD_CD',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'SelectBoxRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Market Basket Name',
    field: 'basketname',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'SelectBoxRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'National Market Share',
    field: 'NAT_MKT_SHARE_TYPE_CD',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'SelectBoxRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Market Share Group',
    field: 'sharegroup',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    resizable: true,
    minWidth: Styles.Width_200,
    maxLength: Styles.Length_30,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'CheckboxRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Subgroup ID',
    field: 'subgroupid',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    dataAlignRight: true,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export default drugFamilyHead;
